import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {ReimbursmentModel, ReimbursmentReportModel} from '../../../../models/ReimbursmentModel';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {MatDialog} from '@angular/material/dialog';
import {ReimbursmentService} from '../service-reimbursment/reimbursment.service';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';

@Component({
  selector: 'app-filter-reimbursment',
  templateUrl: './filter-reimbursment.component.html',
  styleUrls: ['./filter-reimbursment.component.scss']
})
export class FilterReimbursmentComponent  extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() numAnnoMeseData?: any;
  @Input() filter?: ReimbursmentModel;
  @Input() reportSection?: boolean;

  regionData: any;
  localCustomerData: any;
  resourceUnitData: any;

  @Output() dataFiltered = new EventEmitter<any>();

  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;
  @ViewChild(RegionFilterComponent, { static: true }) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent, { static: true }) localCustomerFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;


  constructor(private loaderService: LoaderService,
              private reimbursmentService: ReimbursmentService,
              private numAnnoMeseService: NumAnnoMeseService,
              private providerService: ProviderAnagrafService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new ReimbursmentModel();
    }
    this.filterSingle = AllSettingsFilterModel.getFromReimbursmentModel(this.filter);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
    if (JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.REIMBURSMENT_FILTER))) {
      this.filter = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.REIMBURSMENT_FILTER));
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {
    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();



    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];

          this.filter.localCustomer = this.filterSingle.localCustomer;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();


    observableList.push(getAllRegionFilteredObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];

          this.filter.region = this.filterSingle.region;
          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptNumAnnoMeseChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.REIMBURSMENT_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new ReimbursmentModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromReimbursmentModel(this.filter);

    this.numAnnoMeseService.getAllMonth(this.filter.provider, this.filter.contractType).subscribe(
      (resultYearMonth: any) => {
        const providerDefault = this.filter.provider;
        this.numAnnoMeseData = this.filterFromDxc(providerDefault, resultYearMonth);

        this.filter.numAnnoMese = this.numAnnoMeseData[0] ? this.numAnnoMeseData[0] : null;

        sessionStorage.setItem(this.SESSION_STORAGE_LABELS.REIMBURSMENT_FILTER, JSON.stringify(this.filter));
        this.filterSingle = AllSettingsFilterModel.getFromReimbursmentModel(this.filter);

        this.initFilter(this.filterSingle, isReset);
      }, error => {
        console.log(error);
        this.loaderService.display(false);
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
  }


  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.reimbursmentService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.reimbursmentService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();
    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.REIMBURSMENT_SERVICE}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  openDialogDownloadXlsxQuotation() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();
    this.filter.region = null;
    this.filter.localCustomer = null;

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.REIMBURSMENT_SERVICE},
        {id: 'quotationRequest', value: true}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  ngOnDestroy(): void {
  }


  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ReimbursmentReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    this.loaderService.display(true);
    this.generateReimbursmentXlsx(reportFilter);
  }

  generateReimbursmentXlsx(reportFilter) {
    const fileName = 'Reimbursement';
    this.getNameSubscribe = this.reimbursmentService.getNameGenerateXlsx(this.offset, reportFilter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }),
              fileName + ' - ' + currentDate + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }


}
